// PrivateActionCards — cartes du AYA PRIVATE ACTION ENGINE V1 dans AYA Privé.
// Preview (confirmation explicite) · Receipt · Listes profil · Préparations ·
// Clarification · Ajout panier local (même store que Search).
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { addItem as cartAddItem } from "@/lib/localCartStore";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const fmt = (n) => `${Number(n || 0).toLocaleString("fr-FR").replace(/\u202F|\u00A0/g, " ")} FCFA`;

const S = {
  card: { marginTop: 10, borderRadius: 16, padding: "14px 15px", background: "linear-gradient(160deg, #0A3A22 0%, #062818 60%, #051F13 100%)", border: "1px solid rgba(201,162,75,0.4)", color: "#ECF5EE", maxWidth: 420, fontFamily: "'Manrope','Inter',sans-serif" },
  eyebrow: { fontSize: 10, fontWeight: 800, letterSpacing: 2.5, textTransform: "uppercase", color: "#D9B45B", marginBottom: 8 },
  row: { display: "flex", justifyContent: "space-between", gap: 10, padding: "5px 0", fontSize: 13 },
  k: { color: "rgba(236,245,238,0.6)" },
  v: { fontWeight: 800, textAlign: "right" },
  gold: { color: "#F2C66B", fontWeight: 900 },
  btnP: { width: "100%", marginTop: 10, padding: "12px 14px", borderRadius: 12, border: "none", cursor: "pointer", fontWeight: 900, fontSize: 14, color: "#3A2A05", background: "linear-gradient(180deg,#F7D98A,#EFB94C 55%,#E2A832)", fontFamily: "inherit" },
  btnS: { width: "100%", marginTop: 8, padding: "10px 14px", borderRadius: 12, cursor: "pointer", fontWeight: 700, fontSize: 13, color: "#ECF5EE", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.2)", fontFamily: "inherit" },
};

export function ActionPreviewCard({ data }) {
  const [state, setState] = useState("idle"); // idle | loading | done | cancelled | error
  const [receipt, setReceipt] = useState(null);
  const [err, setErr] = useState(null);

  const confirm = async () => {
    if (state === "loading") return;
    setState("loading");
    try {
      const token = localStorage.getItem("civ_user_token") || "";
      const r = await axios.post(`${API}/v3/private/actions/confirm`, {
        action_token: data.action_token,
        user_id: localStorage.getItem("jsonfirst_civ_userid") || null,
      }, { headers: token ? { Authorization: `Bearer ${token}` } : {}, validateStatus: () => true });
      if (r.data?.ok) { setReceipt(r.data); setState("done"); }
      else if (r.data?.error === "already_executed") { setReceipt(r.data.receipt ? { receipt: r.data.receipt, data: null } : null); setState("done"); }
      else { setErr(r.data?.error || "confirmation impossible"); setState("error"); }
    } catch (_) { setErr("Erreur réseau"); setState("error"); }
  };

  const cancel = async () => {
    try { await axios.post(`${API}/v3/private/actions/cancel`, { action_token: data.action_token }); } catch (_) { /* noop */ }
    setState("cancelled");
  };

  if (state === "done") {
    const d = receipt?.data;
    return (
      <div style={S.card} data-testid="action-receipt-card">
        <div style={S.eyebrow}>✅ Action exécutée · AYA Privé</div>
        <div style={{ fontSize: 16, fontWeight: 900, marginBottom: 6 }}>Taxi commandé</div>
        {d && (
          <>
            <div style={S.row}><span style={S.k}>Départ</span><span style={S.v}>{d.origin}</span></div>
            <div style={S.row}><span style={S.k}>Destination</span><span style={S.v}>{d.destination}</span></div>
            <div style={S.row}><span style={S.k}>Chauffeur</span><span style={S.v}>{d.driver?.name} · {d.driver?.car} ({d.driver?.plate})</span></div>
            <div style={S.row}><span style={S.k}>Arrivée du taxi</span><span style={S.v}>~{d.pickup_eta_min} min</span></div>
            <div style={S.row}><span style={S.k}>Montant</span><span style={{ ...S.v, ...S.gold }}>{fmt(d.price_fcfa)} ({d.payment_method})</span></div>
          </>
        )}
        {receipt?.receipt?.receipt_id && <div style={{ fontSize: 10, color: "rgba(236,245,238,0.45)", marginTop: 8 }}>Reçu {receipt.receipt.receipt_id} · consultable dans Mon Compte → AYA Privé</div>}
      </div>
    );
  }
  if (state === "cancelled") {
    return <div style={{ ...S.card, opacity: 0.7 }} data-testid="action-cancelled-card"><div style={S.eyebrow}>Action annulée</div><div style={{ fontSize: 13 }}>Pas de souci, rien n'a été commandé.</div></div>;
  }
  return (
    <div style={S.card} data-testid="action-preview-card">
      <div style={S.eyebrow}>🚕 Course taxi · Aperçu avant confirmation</div>
      <div style={S.row}><span style={S.k}>Départ</span><span style={S.v}>{data.origin_label}{data.origin_commune ? ` (${data.origin_commune})` : ""}</span></div>
      <div style={S.row}><span style={S.k}>Arrivée</span><span style={S.v}>{data.destination_label}{data.destination_commune ? ` (${data.destination_commune})` : ""}</span></div>
      <div style={S.row}><span style={S.k}>Distance · durée</span><span style={S.v}>{String(data.km).replace(".", ",")} km · ~{data.duration_min} min</span></div>
      <div style={S.row}><span style={S.k}>Prix estimé</span><span style={{ ...S.v, ...S.gold }}>{fmt(data.price_fcfa)}</span></div>
      <div style={S.row}><span style={S.k}>Arrivée du taxi</span><span style={S.v}>~{data.pickup_eta_min} min</span></div>
      <div style={S.row}><span style={S.k}>Paiement</span><span style={S.v}>{data.payment_method}</span></div>
      {state === "error" && <div style={{ fontSize: 12, color: "#FCA5A5", marginTop: 6 }}>⚠️ {err}</div>}
      <button style={S.btnP} onClick={confirm} disabled={state === "loading"} data-testid="action-confirm-btn">
        {state === "loading" ? "Commande en cours…" : "✅ Confirmer la course"}
      </button>
      <button style={S.btnS} onClick={cancel} data-testid="action-cancel-btn">Annuler</button>
    </div>
  );
}

export function ActionListCard({ data }) {
  const items = data?.items || [];
  return (
    <div style={S.card} data-testid="action-list-card">
      <div style={S.eyebrow}>{data.kind === "addresses" ? "📍 Mes adresses AYA" : data.kind === "documents" ? "🧾 Mes documents" : "🔎 Résultats AYA"}</div>
      {items.map((it, i) => (
        <div key={i} style={{ padding: "8px 0", borderBottom: i < items.length - 1 ? "1px solid rgba(255,255,255,0.08)" : "none" }}>
          <div style={{ fontSize: 13.5, fontWeight: 800 }}>
            {it.name || it.title || it.type}{it.is_home ? " · 🏠 Principale" : ""}
          </div>
          <div style={{ fontSize: 11.5, color: "rgba(236,245,238,0.6)", marginTop: 2 }}>
            {[it.address_civ, it.commune, it.ref, it.amount_fcfa ? fmt(it.amount_fcfa) : null, it.status, it.date ? String(it.date).slice(0, 10) : null].filter(Boolean).join(" · ")}
          </div>
        </div>
      ))}
    </div>
  );
}

export function ActionPreparedCard({ data }) {
  const navigate = useNavigate();
  return (
    <div style={S.card} data-testid="action-prepared-card">
      <div style={S.eyebrow}>📋 Préparé par AYA Privé</div>
      <div style={{ fontSize: 14, fontWeight: 800 }}>{data.label}</div>
      {data.amount_fcfa ? <div style={{ ...S.gold, fontSize: 15, marginTop: 4 }}>{fmt(data.amount_fcfa)}</div> : null}
      <button style={S.btnP} onClick={() => navigate(data.route || "/search")} data-testid="action-prepared-open-btn">{data.cta || "Continuer"} →</button>
    </div>
  );
}

export function ActionClarifyCard({ data, ask }) {
  return (
    <div style={S.card} data-testid="action-clarify-card">
      <div style={S.eyebrow}>🤔 Précision nécessaire</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 4 }}>
        {(data.options || []).map((o, i) => (
          <button key={i} data-testid={`action-clarify-opt-${i}`} onClick={() => ask && ask(o.value)}
            style={{ padding: "7px 14px", borderRadius: 999, background: "rgba(217,180,91,0.12)", border: "1px solid rgba(217,180,91,0.5)", color: "#F2C66B", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function ActionCartAddCard({ data }) {
  const [added, setAdded] = useState(false);
  const p = data?.product || {};
  const doAdd = () => {
    for (let i = 0; i < (p.qty || 1); i++) cartAddItem(p);
    setAdded(true);
    toast.success(`🛒 ${p.name} ajouté au panier`);
  };
  return (
    <div style={S.card} data-testid="action-cart-add-card">
      <div style={S.eyebrow}>🛒 Ajout au panier</div>
      <div style={{ fontSize: 14, fontWeight: 800 }}>{p.name}</div>
      <div style={{ fontSize: 12, color: "rgba(236,245,238,0.6)", marginTop: 2 }}>{p.merchant_name}{p.price_fcfa ? ` · ${fmt(p.price_fcfa)}` : ""}{p.qty > 1 ? ` · x${p.qty}` : ""}</div>
      {added
        ? <div style={{ marginTop: 10, fontSize: 13, fontWeight: 800, color: "#2EE27B" }} data-testid="action-cart-added">✓ Dans ton panier</div>
        : <button style={S.btnP} onClick={doAdd} data-testid="action-cart-add-btn">Ajouter au panier</button>}
    </div>
  );
}

export function ActionDeniedCard({ data }) {
  const navigate = useNavigate();
  return (
    <div style={{ ...S.card, borderColor: "rgba(239,68,68,0.5)" }} data-testid="action-denied-card">
      <div style={{ ...S.eyebrow, color: "#FCA5A5" }}>🔒 Autorisation requise</div>
      <div style={{ fontSize: 12.5 }}>L'action <code style={{ color: "#F2C66B" }}>{data.action_id}</code> est désactivée dans tes autorisations.</div>
      <button style={S.btnS} onClick={() => navigate("/mon-compte?tab=aya_prive")} data-testid="action-denied-open-settings">Gérer mes autorisations AYA Privé</button>
    </div>
  );
}
